<template>
    <div v-html="value.description"></div>
</template>
<script>
export default {
    name:"Custom-HTML",
    props:{value:Object}
}
</script>